import { createConditionalInputWrapper } from 'hoc/createConditionalInputWrapper';

export const HideIfAssignmentJob = createConditionalInputWrapper(
  (formData) => !formData.assignment_id,
);

export const ShowIfAssignmentJob = createConditionalInputWrapper(
  (formData) => !!formData.assignment_id,
);
